import {useState, useEffect, useMemo} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'

import {useLocation, useSearchParams} from 'react-router-dom'
import {register} from '../redux/AuthCRUD'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {useSelector, shallowEqual} from 'react-redux' // Added useSelector and shallowEqual

import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import qs from 'querystring'
import { IAuthState } from '../redux/AuthRedux';
import { RootState } from '../../../../setup'; // Assuming RootState is in setup/index.ts
import './style.css'

const initialValues = {
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(1, 'Please enter minimum 1 character')
    .max(50, 'Maximum 50 symbols')
    .required('First name is required'),
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  lastname: Yup.string()
    .min(1, 'Please enter minimum 1 character')
    .max(50, 'Maximum 50 symbols')
    .required('Last name is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
  acceptTerms: Yup.bool().required('You must accept the terms and privacy policy'),
})

export function Registration() {
  const [loading, setLoading] = useState(false)
  const [googleLoginLink, setGoogleLoginLink] = useState('http://localhost:5000/api/v1/auth/google')

  let message: any
  let setMessage: any
  ;[message, setMessage] = useState({})

  const location = useLocation()
  const [isEmailDisabled, setIsEmailDisabled] = useState(false)

  const [searchParams] = useSearchParams()

  const consumerId = useMemo(() => searchParams.get('consumerId'), [searchParams])
  const isFromInvite = useMemo(() => searchParams.get('isFromInvite'), [searchParams])
  const inviteEmail = useMemo(() => searchParams.get('email'), [searchParams])

  console.log(consumerId, isFromInvite, inviteEmail)

  useEffect(() => {
    if (consumerId && isFromInvite && inviteEmail) {
      setGoogleLoginLink(
        `http://localhost:5000/api/v1/auth/google?consumerId=${consumerId}&email=${inviteEmail}`
      )
    }
  }, [consumerId, inviteEmail, isFromInvite])

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        register(values.email, values.firstname, values.lastname, values.password, location.search)
          .then(({data: {api_token, msg, success}}) => {
            setLoading(false)
            setStatus(msg)
            setMessage({
              message: msg,
              color: success === false ? 'alert error-message' : 'alert alert-primary',
              code: true,
            })
            setSubmitting(false)
            // dispatch(auth.actions.register(api_token))
          })
          .catch((err) => {
            setLoading(false)
            setSubmitting(false)
            setStatus('Registration process has broken')
            setMessage({
              msg: 'Registration process has broken' + err.message,
              color: 'error-message',
              code: false,
            })
          })
      }, 1000)
    },
  })

  const { accessToken } = useSelector<RootState, IAuthState>(({ auth }) => auth, shallowEqual); // Moved useSelector here

  useEffect(() => {
    PasswordMeterComponent.bootstrap()

    // Parse the URL parameters
    const paramsString = window.location.search.startsWith('?')
      ? window.location.search.slice(1)
      : window.location.search

    const params = qs.parse(paramsString)
    const {email} = params

    if (email && !isEmailDisabled) {
      ;(async () => {
        try {
          if (accessToken) { // Only make the API call if accessToken is available
            const options = {
              headers: {
                Authorization: `Bearer ${accessToken}`
              },
            };
            const response = await axios.get(
              `${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/check-invite?email=${email}`,
              options
            )

            const {status} = response.data

            if (status === 'ok') {
              formik.setFieldValue('email', email)
              setIsEmailDisabled(true)
            }
          }
        } catch (error) {
          console.error('Error fetching invite status:', error)
        }
      })()
    }
  }, [formik, accessToken]) // Added accessToken to dependencies

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='mb-7 text-center'>
        {/* begin::Title */}
        <h1 className='text-dark mb-1'>Create an account for free</h1>
        {/* end::Title */}

        {/* begin::Subtitle */}
        <div className='text-gray-400 fs-4 mb-4'>No credit card required</div>
        {/* end::Subtitle */}

        {/* begin::Link */}
        <div className='text-gray-400 fw-bold fs-4'>
          Already have an account?
          <Link to='/auth/login' className='link-primary fw-bolder' style={{marginLeft: '5px'}}>
            Sign in here
          </Link>
        </div>
        {/* end::Link */}
      </div>
      {/* end::Heading */}

      {/* begin::Action */}
      {/* <button type='button' className='btn btn-light-primary fw-bolder w-100 mb-10'>
        <img
          alt='Logo'
          src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
          className='h-20px me-3'
        />
        <a href={`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/auth/google`}>Sign in with Google</a>
      </button> */}
      {/* end::Action */}

      <div className='d-flex align-items-center mb-7'>
        <div className='border-bottom border-gray-300 mw-50 w-100'></div>
        <span className='fw-bold text-gray-400 fs-7 mx-2'>OR</span>
        <div className='border-bottom border-gray-300 mw-50 w-100'></div>
      </div>

      {formik.status && message.code && (
        <div className={`mb-lg-15 ${message.color}`}>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}
      {formik.status && !message.code && (
        <div className={`mb-lg-15 alert ${message.color}`}>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}
      {/* begin::Form group Firstname */}
      <div className='row fv-row name'>
        <div className='col-xl-6 mb-7'>
          <label className='form-label fw-bolder text-dark fs-6'>First name</label>
          <input
            placeholder='First name'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('firstname')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.firstname && formik.errors.firstname,
              },
              {
                'is-valid': formik.touched.firstname && !formik.errors.firstname,
              }
            )}
          />
          {formik.touched.firstname && formik.errors.firstname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.firstname}</span>
              </div>
            </div>
          )}
        </div>
        <div className='col-xl-6 mb-7'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6'>Last name</label>
          <input
            placeholder='Last name'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('lastname')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.lastname && formik.errors.lastname,
              },
              {
                'is-valid': formik.touched.lastname && !formik.errors.lastname,
              }
            )}
          />
          {formik.touched.lastname && formik.errors.lastname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.lastname}</span>
              </div>
            </div>
          )}
          {/* end::Form group */}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Email</label>
        <input
          placeholder='Email'
          type='email'
          disabled={isEmailDisabled}
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className='mb-7 fv-row' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>Password</label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        <div className='text-muted'>Use 8+ characters including letters, numbers & symbols</div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <label
            className='form-check-label fw-bold text-gray-700 fs-6'
            htmlFor='kt_login_toc_agree'
          >
            I agree to the{' '}
            <a href='https://clanmeeting.com/terms-and-conditions/' className='ms-1 link-primary'>
              terms
            </a>{' '}
            and{' '}
            <a href='https://clanmeeting.com/privacy-policy/' className='ms-1 link-primary'>
              privacy policy
            </a>
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Form group */}

      {formik.status && message.code && (
        <div className={`mb-lg-15 alert ${message.color}`}>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}
      {formik.status && !message.code && (
        <div className={`mb-lg-15 alert ${message.color}`}>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
        >
          {!loading && <span className='indicator-label'>Create Account</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/*
      <div className='d-flex gap-4'>
        <a
          className='btn btn-secondary w-100 d-flex justify-content-center align-items-center gap-2'
          href={googleLoginLink}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            x='0px'
            y='0px'
            width='24'
            height='24'
            viewBox='0 0 48 48'
          >
            <path
              fill='#FFC107'
              d='M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z'
            ></path>
            <path
              fill='#FF3D00'
              d='M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z'
            ></path>
            <path
              fill='#4CAF50'
              d='M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z'
            ></path>
            <path
              fill='#1976D2'
              d='M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z'
            ></path>
          </svg>
          Google
        </a>
        <a
          className='btn btn-secondary w-100 d-flex justify-content-center align-items-center gap-2'
          href='http://localhost:5000/api/v1/auth/google'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            x='0px'
            y='0px'
            width='24'
            height='24'
            viewBox='0 0 32 32'
          >
            <path
              fill-rule='evenodd'
              d='M 16 4 C 9.371094 4 4 9.371094 4 16 C 4 21.300781 7.4375 25.800781 12.207031 27.386719 C 12.808594 27.496094 13.027344 27.128906 13.027344 26.808594 C 13.027344 26.523438 13.015625 25.769531 13.011719 24.769531 C 9.671875 25.492188 8.96875 23.160156 8.96875 23.160156 C 8.421875 21.773438 7.636719 21.402344 7.636719 21.402344 C 6.546875 20.660156 7.71875 20.675781 7.71875 20.675781 C 8.921875 20.761719 9.554688 21.910156 9.554688 21.910156 C 10.625 23.746094 12.363281 23.214844 13.046875 22.910156 C 13.15625 22.132813 13.46875 21.605469 13.808594 21.304688 C 11.144531 21.003906 8.34375 19.972656 8.34375 15.375 C 8.34375 14.0625 8.8125 12.992188 9.578125 12.152344 C 9.457031 11.851563 9.042969 10.628906 9.695313 8.976563 C 9.695313 8.976563 10.703125 8.65625 12.996094 10.207031 C 13.953125 9.941406 14.980469 9.808594 16 9.804688 C 17.019531 9.808594 18.046875 9.941406 19.003906 10.207031 C 21.296875 8.65625 22.300781 8.976563 22.300781 8.976563 C 22.957031 10.628906 22.546875 11.851563 22.421875 12.152344 C 23.191406 12.992188 23.652344 14.0625 23.652344 15.375 C 23.652344 19.984375 20.847656 20.996094 18.175781 21.296875 C 18.605469 21.664063 18.988281 22.398438 18.988281 23.515625 C 18.988281 25.121094 18.976563 26.414063 18.976563 26.808594 C 18.976563 27.128906 19.191406 27.503906 19.800781 27.386719 C 24.566406 25.796875 28 21.300781 28 16 C 28 9.371094 22.628906 4 16 4 Z'
            ></path>
          </svg>
          Github
        </a>
      </div>
      {/* end::Form group */}
    </form>
  )
}
